import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SubmitButton from "../Common/buttons/SubmitButton";
import Modal from "react-bootstrap/Modal";

const DownloadMaterialsComponent = ({ materials }) => {
  const [modal, setModal] = useState({
    show: false,
    deatils: [],
  });
  const [folder,setFolderData] =  useState()
  const [folderView,setViewFolderData] =  useState(false)
  const { t } = useTranslation();
  const handleDownload = (material) => {
    // Create an anchor element
    const downloadLink = document.createElement("a");
    downloadLink.href = material?.fileName; // Replace with the actual file URL
    downloadLink.download = material?.fileName?.split('/').pop(); // Replace with the desired file name and extension
    downloadLink.target = "_blank"; // Open in a new tab or window

    if (material.fileName.startsWith('http') && !material.fileName.startsWith(window.location.origin)) {
    fetch(material.fileName)
      .then(response => response.blob())
      .then(blob => {
        // Create a blob URL and set it as the href
        const blobUrl = URL.createObjectURL(blob);
        downloadLink.href = blobUrl;
        
        // Trigger the download
        downloadLink.click();
        
        // Clean up by revoking the blob URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      })
      .catch(error => {
        console.error('Error downloading image:', error);
        // Fallback to direct link if fetch fails
        downloadLink.click();
      });
  } else {
    // For same-origin URLs, just trigger the download directly
    downloadLink.click();
  }

    // Trigger a click event on the anchor link
    //downloadLink.click();

    // Clean up the anchor element
    downloadLink.remove();
  };
  const onClickViewModal = (documentId,folderId) => {
    const documentDetails = materials?.data?.find(
      (obj) => obj.id == documentId
    );
    const folderDtails = folder && folder?.find((obj)=>obj.id==folderId);
    
    setModal({
      ...modal,
      show: true,
      deatils: documentId ? documentDetails : folderDtails,
    });
  };
  const handleClose = () => {
    setModal({
      ...modal,
      show: false,
      deatils: [],
    });
  };

  const onClickViewMore = (documentId) =>{
     const documentDetails = materials?.data?.find(
      (obj) => obj.id == documentId
    );
    setFolderData(documentDetails?.folderData);
    setViewFolderData(true)
  }

  return (
    <div className="newsMainBg">
      {materials?.data?.length > 0 ? (
        <>
          <div className="row">
            

            {folder ? (<>
                
                 <div className="backButton">
              <i class="fa fa-angle-double-left" aria-hidden="true" onClick={()=>setFolderData(false)} ></i> Back
            </div>
                {folder.map((item, index) => (
              <div className="col-md-2">
                <div className="newsSubBg">
                  <div className="row" style={{ justifyContent: "center" }}>
                    
                      <img
                        style={{ width: "150px" }}
                        src={item.uploadCategoriesType?.fileIcon}
                        alt=""
                      />
                  

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p>{item?.fileTitle}</p>
                      <div style={{ color: "lightgray" }}>
                        {item?.catId != 4 ? (
                          <i
                            className="fa fa-download"
                            aria-hidden="true"
                            onClick={() => handleDownload(item)}
                          ></i>
                        ) : (
                          <>
                            <i class="fa fa-eye" aria-hidden="true" onClick={() => onClickViewMore(item.id)}></i>
                          </>
                        )}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                          style={{ marginLeft: "10px" }}
                          onClick={() => onClickViewModal("",item.id)}
                        ></i>
                      </div>
                    </div>

                    {/* <div className="col-md-8">
                      <h4>{item?.fileTitle}</h4>
                      <p>{item?.fileDescription}</p>
                      <SubmitButton text="open-download" className="btn btn-primary"/>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
            
            </>):(<>
            {materials?.data?.map((item, index) => (
              <div className="col-md-2">
                <div className="newsSubBg">
                  <div className="row" style={{ justifyContent: "center" }}>
                    
                      <img
                        style={{ width: "150px" }}
                        src={item.uploadCategoriesType?.fileIcon}
                        alt=""
                      />
                  

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p>{item?.fileTitle}</p>
                      <div style={{ color: "lightgray" }}>
                        {item?.catId != 4 ? (
                          <i
                            className="fa fa-download"
                            aria-hidden="true"
                            onClick={() => handleDownload(item)}
                          ></i>
                        ) : (
                          <>
                            {item.folderData.length > 0 &&<i class="fa fa-eye" aria-hidden="true" onClick={() => onClickViewMore(item.id)}></i>}
                          </>
                        )}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                          style={{ marginLeft: "10px" }}
                          onClick={() => onClickViewModal(item.id,"")}
                        ></i>
                      </div>
                    </div>

                    {/* <div className="col-md-8">
                      <h4>{item?.fileTitle}</h4>
                      <p>{item?.fileDescription}</p>
                      <SubmitButton text="open-download" className="btn btn-primary"/>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
        
            </>)}


            
          </div>
              <Modal show={modal.show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>{modal.deatils?.fileTitle}</Modal.Title>
              </Modal.Header>
              <Modal.Body>{modal.deatils?.fileDescription}</Modal.Body>
            </Modal>
        </>
      ) : (
        <>
          <img src="images/download-no-data.png" alt="" />
          <div>{t("sorry_no_data_found")}</div>
        </>
      )}
    </div>
  );
};

export default DownloadMaterialsComponent;
